var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_1841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H31V23H0V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H31V15.3333H0V0Z",
    fill: "#0B4EA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H31V7.66667H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2863 17.7674C9.20348 16.7755 6.21973 14.8014 6.21973 10.9058C6.21973 7.00534 6.41348 5.23242 6.41348 5.23242H16.1639C16.1639 5.23242 16.3529 7.00534 16.3529 10.9058C16.3529 14.8062 13.3691 16.7708 11.2863 17.7674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2857 17.25C9.37246 16.3396 6.63574 14.5283 6.63574 10.9538C6.63574 7.37917 6.81012 5.75 6.81012 5.75H15.7614C15.7614 5.75 15.9309 7.37917 15.9309 10.9538C15.9357 14.5331 13.199 16.3396 11.2857 17.25Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6926 10.0137C12.2109 10.0233 13.2232 10.0425 14.1193 9.74539C14.1193 9.74539 14.1 10.0664 14.1 10.4354C14.1 10.8043 14.1242 11.1254 14.1242 11.1254C13.3007 10.8523 12.2787 10.8475 11.6926 10.8523V12.8264H10.8789V10.8523C10.2976 10.8475 9.27559 10.8523 8.45215 11.1254C8.45215 11.1254 8.47637 10.8043 8.47637 10.4354C8.47637 10.0616 8.45215 9.74539 8.45215 9.74539C9.34824 10.0425 10.3606 10.0233 10.874 10.0137V8.77268C10.4042 8.77268 9.72605 8.79185 8.9559 9.04581C8.9559 9.04581 8.98012 8.72956 8.98012 8.35581C8.98012 7.98685 8.9559 7.66581 8.9559 7.66581C9.72605 7.91977 10.4042 7.94372 10.874 7.93893C10.8498 7.1531 10.6173 6.16602 10.6173 6.16602C10.6173 6.16602 11.0968 6.19956 11.2857 6.19956C11.4795 6.19956 11.9542 6.16602 11.9542 6.16602C11.9542 6.16602 11.7217 7.1531 11.6975 7.93893C12.1673 7.94372 12.8454 7.91977 13.6156 7.66581C13.6156 7.66581 13.5914 7.98685 13.5914 8.35581C13.5914 8.72956 13.6156 9.04581 13.6156 9.04581C12.9948 8.8478 12.3446 8.75544 11.6926 8.77268V10.0185V10.0137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2864 12.6172C10.3225 12.6172 9.80902 13.9349 9.80902 13.9349C9.80902 13.9349 9.5184 13.312 8.73371 13.312C8.2009 13.312 7.8134 13.7768 7.56152 14.2128C8.53027 15.7318 10.0754 16.6709 11.2864 17.2507C12.4973 16.6757 14.0473 15.7318 15.0112 14.2128C14.7593 13.7816 14.3718 13.312 13.839 13.312C13.0543 13.312 12.7637 13.9349 12.7637 13.9349C12.7637 13.9349 12.2551 12.6172 11.2864 12.6172Z",
    fill: "#0B4EA2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_1841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovak);
export default __webpack_public_path__ + "static/media/Slovak.8bbbbd8e6684c5d5d86124641f973add.svg";
export { ForwardRef as ReactComponent };